import React from 'react';
import {get} from 'lodash';
import axios from 'axios';

import {
  availableBanTimes,
  requestCallback,
  CSRF_TOKEN,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import {
  canBan,
} from '../lib/policies';

import UserNoteEditModal from './UserNoteEditModal';

const UsersSameUUIDListPenaltyTools = ({
  userIds,
  uuid
}) => {
  const [
    modal,
    modalSet,
  ] = useModal()  // UserNoteEditModal has its own way of keyboard bindings.

  const bulkDelete = () => {
    requestCallback(axios.delete(`/${gon.currentProvider}/api/bulk/users`, {
      data: {
        ids: userIds,
        authenticity_token: CSRF_TOKEN
      }
    }))
  }

  return (
    <React.Fragment>
      <div className='TableChecker__left__ban-choices'>
        {availableBanTimes.map((x, i) => (
          <a
            key={i}
            className='Badge Badge--orange Badge--icon-lock'
            onClick={() => {
              if (get(userIds, 'length') > 0) {
                modalSet(x.key)
              }
            }}
          >
            {x.value}
          </a>
        ))}

        {canBan('User') &&
          <React.Fragment>
            <a
              className='Badge Badge--wide Badge--red Badge--icon-no-entry'
              onClick={() => {
                if (get(userIds, 'length') > 0) {
                  modalSet('permanent')
                }
              }}
            >
              Ban
            </a>

            <a
              onClick={bulkDelete}
              disabled={userIds.length == 0}
              className='Badge Badge--wide Badge--gray Badge--icon-trash'
            >
              Delete
            </a>
          </React.Fragment>
        }
      </div>

      <UserNoteEditModal
        isActive={modal}
        isBanning
        onToggleModal={() => {
          modalSet(false)
        }}
        userIds={userIds}
        banTime={modal}
        mode='bulk'  // Make sure you supply the `endPoints` when using `mode='bulk'`.
        endPoints={{
          penalty: 'api/bulk/penalties',
          note: 'api/bulk/notes',
        }}
        uuid={uuid}
      />
    </React.Fragment>
  )
}

export default UsersSameUUIDListPenaltyTools
